import axios from 'axios';
import {backendHost} from '../../../../store/config';

const getUsersList = (params) => {
    return axios.get(`${backendHost}/api/admin/v2/users/list`, {params});
};

export {
    getUsersList
}